module.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;


//////////////////
// WEBPACK FOOTER
// external "react-dom"
// module id = react-dom
// module chunks = 0